/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Document } from '../../models/document';

export interface DocumentsAdminControllerUploadFile$Params {
  id: string;

/**
 * Language variant for the file (default: sk)
 */
  lang?: 'sk' | 'en';
      body: {
'file'?: Blob;
}
}

export function documentsAdminControllerUploadFile(http: HttpClient, rootUrl: string, params: DocumentsAdminControllerUploadFile$Params, context?: HttpContext): Observable<StrictHttpResponse<Document>> {
  const rb = new RequestBuilder(rootUrl, documentsAdminControllerUploadFile.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('lang', params.lang, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Document>;
    })
  );
}

documentsAdminControllerUploadFile.PATH = '/admin/documents/{id}/file';
